import { useEffect, useState } from "react";
import { useNavigate, Link } from "react-router-dom";
import api, { apiError } from "@/lib/api";
import { toast } from "sonner";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Plus, Search, ChevronRight } from "lucide-react";

export const ACCESS_STATUS = {
  chef: { label: "Chefredakteur – alle Rechte", cls: "bg-[#0B132B] text-white border-[#0B132B]" },
  aktiv: { label: "Zugang aktiv", cls: "bg-emerald-50 text-emerald-700 border-emerald-200" },
  eingeladen: { label: "Eingeladen", cls: "bg-amber-50 text-amber-700 border-amber-200" },
  freigeschaltet: { label: "Freigeschaltet – nicht eingeladen", cls: "bg-sky-50 text-sky-700 border-sky-200" },
  gesperrt: { label: "Zugang gesperrt", cls: "bg-red-50 text-red-700 border-red-200" },
  kein_login: { label: "Kein Login", cls: "bg-slate-100 text-slate-500 border-slate-200" },
};

export default function UsersPage() {
  const navigate = useNavigate();
  const [items, setItems] = useState([]);
  const [q, setQ] = useState("");

  useEffect(() => {
    api.get("/access").then((r) => setItems(r.data)).catch((e) => toast.error(apiError(e.response?.data?.detail)));
  }, []);

  const filtered = items.filter((i) => !q || `${i.name} ${i.email}`.toLowerCase().includes(q.toLowerCase()));
  const open = (i) => navigate(`/benutzer/${i.person_id}`, { state: { ids: filtered.map((x) => x.person_id) } });

  return (
    <div className="p-6 lg:p-8 max-w-5xl">
      <div className="flex items-center justify-between mb-6 flex-wrap gap-3">
        <div>
          <h1 className="font-display text-3xl font-bold text-slate-900">Benutzer</h1>
          <p className="text-slate-500 mt-1">Alle Mitwirkenden – Zugang freischalten und Rechte je Bereich festlegen.</p>
        </div>
        <Button asChild className="bg-[#0B132B] hover:bg-[#1C2541]" data-testid="add-user-button">
          <Link to="/einstellungen/mitwirkende/neu"><Plus size={16} className="mr-1.5" /> Person hinzufügen</Link>
        </Button>
      </div>
      <div className="relative mb-4 w-64">
        <Search size={16} className="absolute left-3 top-1/2 -translate-y-1/2 text-slate-400" />
        <Input value={q} onChange={(e) => setQ(e.target.value)} placeholder="Suchen…" className="pl-9" data-testid="users-search" />
      </div>
      <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-3" data-testid="users-grid">
        {filtered.map((i) => {
          const st = ACCESS_STATUS[i.status];
          const granted = Object.values(i.permissions).filter((v) => v !== "none").length;
          return (
            <button key={i.person_id} onClick={() => open(i)} data-testid={`user-tile-${i.person_id}`}
              className="text-left bg-white border border-slate-200 rounded-xl p-4 shadow-sm hover:border-slate-400 hover:shadow transition-[border-color,box-shadow]">
              <div className="flex items-start justify-between gap-2">
                <div className="min-w-0">
                  <div className="font-semibold text-slate-900 truncate">{i.name}</div>
                  <div className="text-xs text-slate-500 truncate">{i.email || "keine E-Mail"}</div>
                </div>
                <ChevronRight size={16} className="text-slate-400 shrink-0 mt-1" />
              </div>
              <div className="mt-3 flex items-center justify-between gap-2">
                <span className={`text-[11px] font-medium px-2 py-0.5 rounded border ${st.cls}`} data-testid={`user-status-${i.person_id}`}>{st.label}</span>
                {i.status !== "chef" && <span className="text-[11px] text-slate-400">{granted} von 7 Bereichen</span>}
              </div>
            </button>
          );
        })}
        {filtered.length === 0 && <p className="text-slate-400 text-sm">Keine Personen gefunden.</p>}
      </div>
    </div>
  );
}
